import { useState } from 'react';
import { Loader2, RefreshCw, ChevronDown } from 'lucide-react';

export default function PullMenu({ onPull, loading }) {
    const [open, setOpen] = useState(false);
    return (
        <div className="relative">
            <button onClick={() => setOpen(v => !v)} disabled={loading}
                className="flex items-center gap-1.5 px-3.5 py-2 bg-white dark:bg-slate-900 border border-gray-250 dark:border-slate-800 hover:border-gray-350 dark:hover:border-slate-700 rounded-xl text-xs font-extrabold text-gray-700 dark:text-slate-200 transition-all disabled:opacity-60 hover:scale-102 active:scale-98">
                {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />}
                Pull Data <ChevronDown className="w-3.5 h-3.5 text-gray-400" />
            </button>
            {open && (
                <div className="absolute right-0 top-full mt-1.5 z-50 bg-white/95 dark:bg-slate-900/95 backdrop-blur-md rounded-2xl border border-gray-150 dark:border-slate-800 shadow-xl py-1.5 min-w-[190px] animate-slide-in" onMouseLeave={() => setOpen(false)}>
                    {[
                        ['upsert', 'Upsert (safe)', 'Update source changes & add new entries'],
                        ['insert_only', 'Insert new only', 'Add newly imported entries only'],
                        ['full_replace', 'Full replace ⚠️', 'Wipe current worklist and rebuild']
                    ].map(([mode, label, desc]) => (
                        <button key={mode} onClick={() => { onPull(mode); setOpen(false); }}
                            className="w-full text-left px-4 py-2 hover:bg-indigo-50/50 dark:hover:bg-slate-800/80 transition-colors flex flex-col gap-0.5">
                            <span className="text-xs font-bold text-gray-800 dark:text-slate-200">{label}</span>
                            <span className="text-[9px] text-gray-450 leading-normal">{desc}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
